import React, { Component } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody
} from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers,
  faYenSign,
  faHome,
  faShoppingCart
} from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';

import InsightCard from './select_core_insight/InsightCard.js';

class SelectCoreInsight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      featured: [],
      demographic: [],
      economic: [],
      retail: [],
      social: []
    };
  }

  componentDidMount() {
    fetch('/api/core_insights').then((resp) => resp.json())
      .then((respJson) => {
        const featured = [];
        const demographic = [];
        const economic = [];
        const retail = [];
        const social = [];

        respJson.forEach((coreInsight) => {
          if (coreInsight.featured) {
            featured.push(coreInsight);
          } else {
            switch (coreInsight.category) {
              case 'Demographic': demographic.push(coreInsight);
                break;
              case 'Economic': economic.push(coreInsight);
                break;
              case 'Retail': retail.push(coreInsight);
                break;
              case 'Social & Wellness': social.push(coreInsight);
                break;
              default: break;
            }
          }
        });

        this.setState({ featured, demographic, economic, retail, social });
      });
  }

  getCategoryIcon(category) {
    let icon = null;

    switch (category) {
      case 'Demographic': icon = faUsers;
        break;
      case 'Economic': icon = faYenSign;
        break;
      case 'Retail': icon = faShoppingCart;
        break;
      case 'Social & Wellness': icon = faHome;
        break;
      default: break;
    }

    return icon;
  }

  renderSectionTitle(icon, title) {
    return (
      <div className="sl-section-header mt-2">
        <h5>
          {icon && (
            <span className="fa-layers fa-fw mr-2">
              <FontAwesomeIcon icon={faCircle} transform="grow-15" />
              <FontAwesomeIcon icon={icon} />
            </span>
          )}
          {title}
        </h5>
      </div>
    );
  }

  render() {
    const { featured, demographic, economic, retail, social } = this.state;

    const featuredCards = featured.map((item, i) => (
      <InsightCard
        key={'featured-' + i}
        id={item.id}
        header={true}
        name={item.category}
        content={item.name}
        endpoint={item.endpoint}
        icon={this.getCategoryIcon(item.category)} />
    ));

    const demographicCards = demographic.map((item, i) => (
      <InsightCard
        key={'demographic-' + i}
        type="Demographic"
        id={item.id}
        name={item.name}
        content={item.content}
        endpoint={item.endpoint}
        icon={faUsers} />
    ));

    const economicCards = economic.map((item, i) => (
      <InsightCard
        key={'economic-' + i}
        type="Economic"
        id={item.id}
        name={item.name}
        content={item.content}
        endpoint={item.endpoint}
        icon={faYenSign} />
    ));

    const retailCards = retail.map((item, i) => (
      <InsightCard
        key={'retail-' + i}
        type="Retail & Consumption"
        id={item.id}
        name={item.name}
        content={item.content}
        endpoint={item.endpoint}
        icon={faShoppingCart} />
    ));

    const socialCards = social.map((item, i) => (
      <InsightCard
        key={'social-' + i}
        type="Social & Wellness"
        id={item.id}
        name={item.name}
        content={item.content}
        endpoint={item.endpoint}
        icon={faHome} />
    ));

    return (
      <Container fluid={true} className="sl-view-shell">
        <div className="sl-view-hero">
          <div>
            <div className="sl-view-kicker">Core Insights</div>
            <h1 className="sl-view-title">Explore Curated Insights</h1>
            <p className="sl-view-subtitle">Browse featured and category-based insights to jump directly into actionable prefecture analysis.</p>
          </div>
          <span className="sl-view-meta">Insight Library</span>
        </div>

        <Row>
          <Col md="12">
            <Card className="mb-0 sl-panel">
              <CardHeader className="sl-panel-header">Select a core insight</CardHeader>
              <CardBody>
                {this.renderSectionTitle(null, 'Featured')}
                <Row>{featuredCards}</Row>

                {this.renderSectionTitle(faUsers, 'Demographic Core Insights')}
                <Row>{demographicCards}</Row>

                {this.renderSectionTitle(faYenSign, 'Economic Core Insights')}
                <Row>{economicCards}</Row>

                {this.renderSectionTitle(faShoppingCart, 'Retail Core Insights')}
                <Row>{retailCards}</Row>

                {this.renderSectionTitle(faHome, 'Social & Wellness Core Insights')}
                <Row>{socialCards}</Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default SelectCoreInsight;
